import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "nav.dashboard": "Dashboard",
      "nav.create": "Create",
      "nav.arbitrators": "Arbitrators",
      "nav.reputation": "Reputation",
      "wallet.connecting": "Connecting...",
      "wallet.connect": "Connect op_Wallet",
      "wallet.connected": "OPNET",
      "footer.text": "MotoSettle <strong>v1.0.0</strong> — Trustless Escrow on OP_NET",
      "footer.gitlab": "GitLab ↗",
      "dash.hero_eyebrow": "⚡ OP_NET Protocol",
      "dash.hero_title1": "Trustless Escrow",
      "dash.hero_title2": "On-Chain, Always.",
      "dash.hero_sub": "Non-custodial escrow with built-in dispute resolution, arbitrator marketplace, and reputation scoring — deployed on OP_NET.",
      "dash.btn_create": "Create Escrow",
      "dash.btn_arb": "Arbitrator Marketplace",
      "dash.overview": "Protocol Overview",
      "dash.syncing": "Syncing…",
      "dash.stat_total_escrows": "Total Escrows",
      "dash.stat_active_escrows": "Active Escrows",
      "dash.stat_total_volume": "Total Volume",
      "dash.stat_total_fees": "Total Fees",
      "dash.stat_total_disputes": "Total Disputes",
      "dash.stat_resolved": "Resolved",
      "dash.stat_expired": "Expired",
      "dash.stat_dispute_rate": "Dispute Rate",
      "dash.unit_tokens": "tokens",
      "dash.no_indexer": "No indexer connected",
      "dash.btn_create_pl": "+ Create Escrow",
      "dash.btn_browse_arb": "Browse Arbitrators",
      "dash.btn_rep_exp": "Reputation Explorer"
    }
  },
  "es-419": {
    translation: {
      "nav.dashboard": "Panel",
      "nav.create": "Crear",
      "nav.arbitrators": "Árbitros",
      "nav.reputation": "Reputación",
      "wallet.connecting": "Conectando...",
      "wallet.connect": "Conectar op_Wallet",
      "wallet.connected": "OPNET",
      "footer.text": "MotoSettle <strong>v1.0.0</strong> — Depósito en garantía sin confianza en OP_NET",
      "footer.gitlab": "GitLab ↗",
      "dash.hero_eyebrow": "⚡ Protocolo OP_NET",
      "dash.hero_title1": "Depósito Cripto",
      "dash.hero_title2": "En la Cadena, Siempre.",
      "dash.hero_sub": "Depósito sin custodia con resolución de disputas integrada, mercado de árbitros y puntuación de reputación; implementado en OP_NET.",
      "dash.btn_create": "Crear Depósito",
      "dash.btn_arb": "Mercado de Árbitros",
      "dash.overview": "Descripción del Protocolo",
      "dash.syncing": "Sincronizando…",
      "dash.stat_total_escrows": "Depósitos Totales",
      "dash.stat_active_escrows": "Depósitos Activos",
      "dash.stat_total_volume": "Volumen Total",
      "dash.stat_total_fees": "Tarifas Totales",
      "dash.stat_total_disputes": "Disputas Totales",
      "dash.stat_resolved": "Resueltos",
      "dash.stat_expired": "Expirados",
      "dash.stat_dispute_rate": "Tasa de Disputas",
      "dash.unit_tokens": "tokens",
      "dash.no_indexer": "Sin indexador conectado",
      "dash.btn_create_pl": "+ Crear Depósito",
      "dash.btn_browse_arb": "Explorar Árbitros",
      "dash.btn_rep_exp": "Explorar Reputación"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    interpolation: { escapeValue: false }
  });

export default i18n;
